/**
 * An enum that contains all cookie keys that we need to use in the application
 */
export const enum CookieKeys {
  USER_SELECT = '_UserSelect'
}
